import { Spin } from "antd";
import { memo, type ReactElement, type ReactNode } from "react";

import { BTIconLoadingOutlined } from "commonComponents/btWrappers/BTIcon";

interface IBTSpinProps {
    className?: string;
    spinning?: boolean;
    // style?: React.CSSProperties;
    size?: "small" | "default" | "large";
    tip?: string;
    delay?: number;
    // wrapperClassName?: string;
    indicator?: ReactElement<HTMLElement>;
    children?: ReactNode;
}

function BTSpinInternal({ children, ...otherProps }: IBTSpinProps) {
    return (
        // eslint-disable-next-line react/forbid-elements
        <Spin indicator={<BTIconLoadingOutlined spin />} {...otherProps}>
            {children}
        </Spin>
    );
}

export const BTSpin = memo(BTSpinInternal);
